module.exports = "/fonts/ElevanceSans-Semibold.fce53d38de2036ba2ba364a6ac7e50d3.eot";